import React from 'react';
import styles from './styles.module.scss';
import {Link} from 'react-router-dom';
import {APP_PATHS} from '../../../constants';
import Auth from './auth';
import Info from './info';
import {useUserContext} from 'providers/user-context';
import {Skeleton} from '@chakra-ui/react';
import {useQuery} from 'react-query';
import {activityStats} from 'api/user';
import {QUERY_KEYS} from '../../../constants';
import { ActivityStatsResponse } from 'types/user'; 

const Header: React.FC = () => {
  const {user, userLoading} = useUserContext();

    // Use React Query to fetch user activity stats
    const { data: stats} = useQuery<ActivityStatsResponse>(
      [QUERY_KEYS.USER.ACTIVITY_STATS],
      activityStats, {
      refetchInterval: 1000 * 10,     // Auto-refresh every 10 secs, even if data is fresh
      refetchIntervalInBackground: false,   // Do not poll when browser tab is in the background (even if data is stale)
      staleTime: 1000 * 10,           // Consider data as fresh for 10 seconds (in this period, any  reftach on window focus or mount will be ignored. Except for refetchInterval which will always run)
      refetchOnWindowFocus: true,     // Refetching on tab focus, AND data is stale
      refetchOnMount: true,           // Refetching on component mount, AND data is stale
      keepPreviousData: true,         // Keep previous data while fetching new data
      enabled: !!user,                // Only run the query (and any refetch) if user exists (is logged in)
      retry: (failureCount, error: any) => {
        const status = error?.status;
        // Retry once only if it's NOT one of these status codes
        return failureCount < 1 && ![400, 401, 404, 429, 500].includes(status);
      },
      retryDelay: () => 4000, // 4s delay before the single retry
    });        
  
  return (
    <div className={styles.wrapper}>
      <Link to={APP_PATHS.BASE} className={styles.link}>
          <img src={'/images/logo.png'} alt="TonzOcash" className={styles.tonzoLogo} loading='eager'/>
      </Link>
      {userLoading ? (
        <div className={styles.skeletonWrapper}>
          <Skeleton height="40px" width="100px" className={styles.skeleton} />
          <Skeleton height="40px" width="130px" className={styles.skeleton} />
        </div>
      ) : !!user ? (
        <Info userData={user} loading={userLoading} userStats={stats}/>
      ) : (
        <Auth />
      )}
    </div>
  );
};

export default Header;
